import React, { useLayoutEffect, useState, useEffect } from 'react';
import 'react-simple-keyboard/build/css/index.css';
import Styles from './orderItem.module.scss';
import cn from 'classnames';
import CustomKeyboard from '@components/common/CustomKeyboard/index';
import { LABEL } from '../../veriables';
import { flowType } from '../../utility/userInfo';

const createTable = ({
  type,
  maxLength,
  isAlpha,
  name,
  placeholder,
  onSubmit,
  isOpen,
  specialValue,
  cancelModal
}) => {
 
  const isKiosk = flowType() === 'kiosk';
  const [keyboardType, setKeyboardType] = useState(isKiosk ? 'kiosk' : 'numericAlpha');
  const [inputs, setInputs] = useState({
    [name]: specialValue
  });
  const [inputName, setInputName] = useState(name);
  const [isSwipedDown, setSwipedDown] = useState(true);
  const [browserOrtablet, setBrowserOrtablet] = useState(true);

  const closeKeyboard = () => {
    setSwipedDown(false);
  };

  const onClickBtn = (e) => {
    const value = e === '{bksp}' ? { ...inputs, [inputName]: inputs[inputName]?.slice(0, -1) } : { ...inputs, [inputName]: inputs[inputName] ? inputs[inputName].concat(e) : ''.concat(e) };
    setInputs({
      ...inputs,
      [inputName]: value[inputName]
    });
  };
  useLayoutEffect(() => {
    if (isAlpha) {
      setKeyboardType('numericAlpha');
    } else {
      setKeyboardType(type === 'number' ? 'numericDefault' : 'text');
    }
  }, [type]);

  useLayoutEffect(() => {
    setInputs({
      ...inputs, [name]: specialValue
    });
  }, [isOpen]);

  const getInputValue = (inputNameDat) => {
    return (inputs[inputNameDat]) || '';
  };

  const buttonTheme = {
    '{done}': {
      class: 'bgGreen',
    }
  };

  const submit = () => {
    onSubmit(inputs[inputName]);
  };

  const handleBlur = () => {
    setSwipedDown(true);
    const element = document.querySelector(`#${name}`);
    element.blur();
  };

  useEffect(() => {
    if (window.ReactNativeWebView) {
      setBrowserOrtablet(false);
    } else {
      setBrowserOrtablet(true);
    }
  }, [])

    const tabletMode = (data) => {
      setInputName(data.name); setKeyboardType(data.type); handleBlur();
    }
    const browserMode = (data) => {
      setInputName(data.name); setKeyboardType(data.type); 
    }

    const handleChange = (event) => {
      setInputs({
        ...inputs, [name]: event.target.value
      });

    }

  return (
    <div className={cn('col-12 my-1 p-0 large-input row mx-0 justify-content-center')}>
      <div className="fs-20 px-2 fw-700 col-12">
        {LABEL().SPECIAL_INSTRUCTIONS} &nbsp;
      </div>
      <div className="fs-20 px-2 py-1 fw-700 text-lowercase">
        ({20 - (getInputValue(name)?.length || 0)} of {20} remaining)
      </div>
      <div className={cn('col-12 p-0 my-2 position-relative', inputName === name ? 'border br-5 od-container-card-border border-color-primary' : '')}>
        <input
          id={name}
          type="text"
          name={name}
          className={cn('col-12 form-control')}
          style={{ height: isKiosk ? '5vh' : '10vh', fontSize: isKiosk ? '' : '5vh' }}
          placeholder={placeholder}
          value={getInputValue(name)}
          maxLength="20"
          // onFocus={() => { handleBlur(); setInputName(name); setKeyboardType('text'); }}
          onFocus={() => { browserOrtablet ? browserMode({ name: name, type: 'text'}) : tabletMode({ name: name, type: 'text'}) }}
          onChange={(e)=> browserOrtablet ? handleChange(e) : null}
        />
      </div>
      {isKiosk ? (
        <div className={cn('m-0 pt-2 w-100 row align-items-end justify-content-center')}>
          <div className="col-6 pl-0">
            <button
              className={cn('w-100 mt-2 btn100 btn-secondary od-btn-secondary')}
              type="submit"
              onClick={() => cancelModal(false)}
            >
              <div className="fs-30">{LABEL().KIOSK_CANCEL}</div>
            </button>
          </div>
          <div className="col-6 pr-0">
            <button
              className={cn('w-100 mt-2 btn100 btn-primary btn-ripple od-btn-primary')}
              type="submit"
              onClick={() => submit()}
            >
              <div className="fs-30">{LABEL().ADD_NOTE}</div>
            </button>
          </div>
        </div>) : (
          <button
            className={cn('w-100 mt-2 btn btn-primary btn-ripple od-btn-primary')}
            type="button"
            onClick={() => submit()}
            style={{ height: '10vh' }}
          >
            <div className="fs-18">{LABEL().SUBMIT}</div>
          </button>) }
      {(isSwipedDown && !browserOrtablet) && (
        <div className={cn('p-1 background-primary od-app-background-color od-border-secondary', keyboardType === 'number' || keyboardType === 'numericAlpha' ? Styles.keyboard : Styles.keyboard1)}>
          <CustomKeyboard
            setKeyboardType={setKeyboardType}
            onClickBtn={(e) => onClickBtn(e)}
            type={isKiosk ? 'kiosk' : keyboardType}
            typed={inputs[inputName] || ''}
            closeKeyboard={closeKeyboard}
            btnSize={isKiosk ? 'btn35' : 'btn'}
            customClass="fs-30 background-primary od-app-background-color"
            maxLength={maxLength}
            buttonTheme={buttonTheme}
          />
        </div>
      )}
    </div>
  );
};

export default createTable;
